import React from 'react';
import EditStockItem from '.';
import { useAuthContext } from '../../../../context/AuthContext';
const EnhanceEditStockItem = () => {
    const { business } = useAuthContext();
    return <EditStockItem business={business} />;
};
export default EnhanceEditStockItem;